<template>
  <div class="chartersWrapper customEmptyLegsAndSpacesWrapper">
    <div v-if="isForm" class="availabilityDashboard availabilityDashboard--charter">
      <vue-scroll :ops="ops">
        <CustomEmptyLegsAndSpacesForm/>
      </vue-scroll>
    </div>
    <div v-else class="flightUploadsDashboard js-tabBox flightUploadsDashboard--charter">
      <vue-scroll :ops="ops">
        <div class="flightUploadsDashboard__header customEmptyLegsAndSpacesDashboard__header">
          <div class="customEmptyLegsAndSpacesDashboard__headerTop">
            <div class="flightUploadsDashboard__title">Custom Empty Legs And Spaces</div>
            <button
              class="buttonCreate buttonGenerateHtml"
              :disabled="!selectedCurrentRecords.length || generateHtmlLoading"
              @click="generateHtml"
            >
              Generate html
            </button>
            <router-link class="buttonCreate" to="/admin/custom-empty-legs-and-spaces/new">Create</router-link>
          </div>
          <div class="flightUploadsDashboard__nav">
            <div class="flightUploadsDashboard__nav-item js-tabNavItem" @click="tabActivate">
              <span class="text">Current</span>
            </div>
            <div class="flightUploadsDashboard__nav-item js-tabNavItem" @click="tabActivate">
              <span class="text">Historical</span>
            </div>
          </div>
        </div>
        <div class="customEmptyLegsAndSpacesDashboard__intro">
          <div class="customEmptyLegsAndSpacesDashboard__row">
            <div class="customEmptyLegsAndSpacesDashboard__row__title">Intro</div>
            <textarea v-model="intro" />
          </div>
        </div>
        <div class="flightUploadsDashboard__content">
          <div class="flightUploadsDashboard__content-item js-tabContentItem">
            <CustomEmptyLegsAndSpacesList
              :historical="false"
              :multipleSelect="true"
              @selection-change="setSelectedCurrentRecords"
            />
          </div>
          <div class="flightUploadsDashboard__content-item js-tabContentItem">
            <CustomEmptyLegsAndSpacesList :historical="true"/>
          </div>
        </div>
      </vue-scroll>
    </div>
  </div>
</template>

<script>
  import { aircraftsAPI } from '@/api/aircrafts'
  import CustomEmptyLegsAndSpacesForm from '@/components/dashboard/CustomEmptyLegsAndSpacesForm/CustomEmptyLegsAndSpacesForm'
  import CustomEmptyLegsAndSpacesList from '@/components/dashboard/CustomEmptyLegsAndSpacesList/CustomEmptyLegsAndSpacesList'
  import { Tabs } from '@/js/plugins/tabs'
  import '@/views/dashboard/common/FlightUploads/FlightUploads.styl'
  import './CustomEmptyLegsAndSpaces.styl'

  export default {
    name: 'CustomEmptyLegsAndSpaces',
    data: () => ({
      intro: '',
      tabs: new Tabs('.js-tabNavItem', '.js-tabContentItem'),
      selectedCurrentRecords: [],
      generateHtmlLoading: false,
      ops: {
        scrollPanel: {
          initialScrollX: false,
          scrollingX: false,
        },
        rail: {
          size: '3px',
        },
        bar: {
          size: '3px',
          background: 'rgba(0,0,0,0.1)',
        },
      },
    }),
    computed: {
      isForm () {
        const last = this.$route.path.split('/').pop()
        return last !== 'custom-empty-legs-and-spaces'
      },
    },
    watch: {
      $route () {
        this.initTabs()
      },
    },
    mounted () {
      this.initTabs()
    },
    methods: {
      initTabs () {
        if (!this.isForm) {
          this.$nextTick(() => {
            this.tabs.addActiveForMouted()
          })
        }
      },
      tabActivate (event) {
        this.tabs.addActiveForClick(event.currentTarget)
      },
      setSelectedCurrentRecords (records) {
        this.selectedCurrentRecords = records
      },
      generateHtml () {
        if (!this.selectedCurrentRecords.length || this.generateHtmlLoading) return

        const emptyLegIds = this.selectedCurrentRecords
          .map(item => item.emptyLegId)

        if (!emptyLegIds.length) return

        this.generateHtmlLoading = true

        aircraftsAPI.generateEmptyLegsHtml({ emptyLegIds, intro: this.intro })
          .then(({ data }) => {
            const downloadLink = document.createElement('a')
            const blob = new Blob(['\ufeff', data], { type: 'text/html;charset=utf-8' })
            const url = window.URL.createObjectURL(blob)

            downloadLink.href = url
            downloadLink.download = `empty-legs_${new Date().toLocaleDateString().replaceAll('/', '-')}.html`
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(url)
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            this.generateHtmlLoading = false
          })
      },
    },
    components: {
      CustomEmptyLegsAndSpacesForm,
      CustomEmptyLegsAndSpacesList,
    },
  }
</script>
